export default __webpack_public_path__ + "static/media/WaveTexture.def6b63a.svg";